export const BRAND = {
  green: '#1A472A',
  orange: '#FF5722',
  sand: '#FFF8F3',
  dark: '#1A1A1A',
  gray: '#666666',
  lightGray: '#f4f4f4',
};

export const LOGO_URL =
  'https://wjwcuakqeesxnbjznajh.supabase.co/storage/v1/object/sign/images/ibomopen2025.png?token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1cmwiOiJpbWFnZXMvaWJvbW9wZW4yMDI1LnBuZyIsImlhdCI6MTc0NDkzOTQzMiwiZXhwIjoxNzc2NDc1NDMyfQ.mmWexTyuYcA9LTq1l0_mm40xqptR3LssIEqUPCGOv4M';

export interface TemplatePlaceholder {
  key: string;
  label: string;
  example: string;
}

export interface EmailTemplateType {
  id: string;
  name: string;
  dbName: string;
  description: string;
  placeholders: TemplatePlaceholder[];
  defaultSubject: string;
  defaultHtml: string;
}

function brandedLayout(content: string): string {
  return `<div style="background-color: ${BRAND.lightGray}; padding: 40px 20px; font-family: 'Helvetica Neue', Arial, sans-serif; -webkit-font-smoothing: antialiased;">
  <div style="max-width: 600px; margin: 0 auto; background: #ffffff; border-radius: 12px; overflow: hidden; box-shadow: 0 4px 24px rgba(0,0,0,0.06);">
    <div style="background-color: ${BRAND.green}; padding: 36px 32px; text-align: center;">
      <img src="${LOGO_URL}" alt="Ibom Open 2025" style="max-width: 180px; height: auto;" />
    </div>
    <div style="height: 4px; background: linear-gradient(90deg, ${BRAND.orange} 0%, ${BRAND.green} 100%);"></div>
    <div style="padding: 40px 36px;">
${content}
    </div>
    <div style="background-color: #f9fafb; padding: 24px 36px; text-align: center; border-top: 1px solid #e5e7eb;">
      <p style="color: ${BRAND.green}; font-weight: 700; font-size: 13px; margin: 0 0 8px; text-transform: uppercase; letter-spacing: 0.5px;">Get the Official App</p>
      <p style="color: ${BRAND.gray}; font-size: 12px; margin: 0 0 12px; line-height: 1.5;">Live scores, leaderboards & updates in your pocket</p>
      <div>
        <!--[if mso]><table role="presentation" align="center"><tr><td style="padding: 0 6px;"><![endif]-->
        <a href="{{appStoreUrl}}" style="display: inline-block; margin: 0 4px 8px; text-decoration: none;">
          <img src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg" alt="Download on the App Store" style="height: 36px; width: auto;" />
        </a>
        <!--[if mso]></td><td style="padding: 0 6px;"><![endif]-->
        <a href="{{playStoreUrl}}" style="display: inline-block; margin: 0 4px 8px; text-decoration: none;">
          <img src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg" alt="Get it on Google Play" style="height: 36px; width: auto;" />
        </a>
        <!--[if mso]></td></tr></table><![endif]-->
      </div>
    </div>
    <div style="background-color: ${BRAND.green}; padding: 28px 36px; text-align: center;">
      <p style="color: rgba(255,255,255,0.85); font-size: 13px; margin: 0 0 6px; line-height: 1.5;">&copy; 2004-${new Date().getFullYear()} Ibom Open Golf Tournament. All rights reserved.</p>
      <p style="color: rgba(255,255,255,0.6); font-size: 12px; margin: 0; line-height: 1.5;">Ibom Golf &amp; Country Club, Uyo, Akwa Ibom State, Nigeria</p>
      <div style="margin-top: 16px;">
        <a href="https://ibomopen.com" style="color: ${BRAND.orange}; text-decoration: none; font-size: 13px; font-weight: 600;">ibomopen.com</a>
      </div>
    </div>
  </div>
</div>`;
}

const registrationContent = `      <h2 style="color: ${BRAND.green}; margin: 0 0 24px; font-size: 22px; font-weight: 700;">Registration Confirmation</h2>
      <p style="color: ${BRAND.dark}; font-size: 16px; line-height: 1.6; margin: 0 0 16px;">Dear {{firstName}} {{lastName}},</p>
      <p style="color: #444; font-size: 15px; line-height: 1.7; margin: 0 0 16px;">Thank you for registering for the <strong>Ibom Open 2025</strong>. Your registration has been received and is being processed.</p>
      <div style="background-color: ${BRAND.sand}; border-left: 4px solid ${BRAND.orange}; padding: 20px 24px; margin: 28px 0; border-radius: 0 8px 8px 0;">
        <table style="width: 100%; border-collapse: collapse;">
          <tr>
            <td style="color: ${BRAND.gray}; padding: 6px 16px 6px 0; font-size: 14px; white-space: nowrap;">Registration Number</td>
            <td style="color: ${BRAND.dark}; font-weight: 600; padding: 6px 0; font-size: 14px;">{{registrationNumber}}</td>
          </tr>
          <tr>
            <td style="color: ${BRAND.gray}; padding: 6px 16px 6px 0; font-size: 14px; white-space: nowrap;">Shirt Size</td>
            <td style="color: ${BRAND.dark}; font-weight: 600; padding: 6px 0; font-size: 14px;">{{shirtSize}}</td>
          </tr>
        </table>
      </div>
      <p style="color: #444; font-size: 15px; line-height: 1.7; margin: 0 0 8px;"><strong>Next Steps:</strong></p>
      <ul style="color: #444; font-size: 15px; line-height: 1.8; margin: 0 0 24px; padding-left: 20px;">
        <li>Your registration will be reviewed within 24 hours</li>
        <li>Once approved, you will receive further details</li>
        <li>Please keep your registration number for reference</li>
      </ul>
      <div style="text-align: center; margin: 32px 0;">
        <a href="https://ibomopen.com" style="display: inline-block; background-color: ${BRAND.orange}; color: #ffffff; text-decoration: none; padding: 14px 36px; border-radius: 8px; font-weight: 600; font-size: 15px;">Visit Our Website</a>
      </div>
      <p style="color: #444; font-size: 15px; line-height: 1.7; margin: 0 0 4px;">If you have any questions, please contact us at <a href="mailto:info@ibomopen.com" style="color: ${BRAND.orange}; text-decoration: none;">info@ibomopen.com</a></p>
      <p style="color: ${BRAND.dark}; font-size: 15px; line-height: 1.7; margin: 24px 0 0;">Best regards,<br><strong style="color: ${BRAND.green};">The Ibom Open Team</strong></p>`;

const paymentContent = `      <h2 style="color: ${BRAND.green}; margin: 0 0 24px; font-size: 22px; font-weight: 700;">Payment Confirmation</h2>
      <p style="color: ${BRAND.dark}; font-size: 16px; line-height: 1.6; margin: 0 0 16px;">Dear {{firstName}} {{lastName}},</p>
      <p style="color: #444; font-size: 15px; line-height: 1.7; margin: 0 0 16px;">Thank you for your payment for the <strong>{{tournamentName}}</strong>. Your transaction has been successfully processed.</p>
      <div style="background-color: ${BRAND.sand}; border-left: 4px solid ${BRAND.orange}; padding: 20px 24px; margin: 28px 0; border-radius: 0 8px 8px 0;">
        <table style="width: 100%; border-collapse: collapse;">
          <tr>
            <td style="color: ${BRAND.gray}; padding: 6px 16px 6px 0; font-size: 14px; white-space: nowrap;">Tournament</td>
            <td style="color: ${BRAND.dark}; font-weight: 600; padding: 6px 0; font-size: 14px;">{{tournamentName}}</td>
          </tr>
          <tr>
            <td style="color: ${BRAND.gray}; padding: 6px 16px 6px 0; font-size: 14px; white-space: nowrap;">Amount Paid</td>
            <td style="color: ${BRAND.dark}; font-weight: 600; padding: 6px 0; font-size: 14px;">{{amount}}</td>
          </tr>
          <tr>
            <td style="color: ${BRAND.gray}; padding: 6px 16px 6px 0; font-size: 14px; white-space: nowrap;">Transaction Reference</td>
            <td style="color: ${BRAND.dark}; font-weight: 600; padding: 6px 0; font-size: 14px;">{{reference}}</td>
          </tr>
        </table>
      </div>
      <p style="color: #444; font-size: 15px; line-height: 1.7; margin: 0 0 16px;">Your registration is now complete. We look forward to seeing you at the <strong>{{tournamentName}}</strong>.</p>
      <div style="text-align: center; margin: 32px 0;">
        <a href="https://ibomopen.com" style="display: inline-block; background-color: ${BRAND.orange}; color: #ffffff; text-decoration: none; padding: 14px 36px; border-radius: 8px; font-weight: 600; font-size: 15px;">Visit Our Website</a>
      </div>
      <p style="color: #444; font-size: 15px; line-height: 1.7; margin: 0 0 4px;">If you have any questions, please contact us at <a href="mailto:info@ibomopen.com" style="color: ${BRAND.orange}; text-decoration: none;">info@ibomopen.com</a></p>
      <p style="color: ${BRAND.dark}; font-size: 15px; line-height: 1.7; margin: 24px 0 0;">Best regards,<br><strong style="color: ${BRAND.green};">The Ibom Open Team</strong></p>`;

const statusChangeContent = `      <h2 style="color: ${BRAND.green}; margin: 0 0 24px; font-size: 22px; font-weight: 700;">Registration Status Update</h2>
      <p style="color: ${BRAND.dark}; font-size: 16px; line-height: 1.6; margin: 0 0 16px;">Dear {{firstName}} {{lastName}},</p>
      <p style="color: #444; font-size: 15px; line-height: 1.7; margin: 0 0 16px;">We are writing to inform you that your registration status has been updated.</p>
      <div style="background-color: ${BRAND.sand}; border-left: 4px solid ${BRAND.orange}; padding: 20px 24px; margin: 28px 0; border-radius: 0 8px 8px 0;">
        <table style="width: 100%; border-collapse: collapse;">
          <tr>
            <td style="color: ${BRAND.gray}; padding: 6px 16px 6px 0; font-size: 14px; white-space: nowrap;">New Status</td>
            <td style="color: ${BRAND.dark}; font-weight: 600; padding: 6px 0; font-size: 16px;">{{status}}</td>
          </tr>
        </table>
      </div>
      <p style="color: #444; font-size: 15px; line-height: 1.7; margin: 0 0 16px;">If you believe this update was made in error or have any questions, please do not hesitate to contact us.</p>
      <div style="text-align: center; margin: 32px 0;">
        <a href="https://ibomopen.com" style="display: inline-block; background-color: ${BRAND.orange}; color: #ffffff; text-decoration: none; padding: 14px 36px; border-radius: 8px; font-weight: 600; font-size: 15px;">Visit Our Website</a>
      </div>
      <p style="color: #444; font-size: 15px; line-height: 1.7; margin: 0 0 4px;">If you have any questions, please contact us at <a href="mailto:info@ibomopen.com" style="color: ${BRAND.orange}; text-decoration: none;">info@ibomopen.com</a></p>
      <p style="color: ${BRAND.dark}; font-size: 15px; line-height: 1.7; margin: 24px 0 0;">Best regards,<br><strong style="color: ${BRAND.green};">The Ibom Open Team</strong></p>`;

const welcomeContent = `      <h2 style="color: ${BRAND.green}; margin: 0 0 24px; font-size: 22px; font-weight: 700;">Welcome to the {{tournamentName}}!</h2>
      <p style="color: ${BRAND.dark}; font-size: 16px; line-height: 1.6; margin: 0 0 16px;">Dear {{firstName}} {{lastName}},</p>
      <p style="color: #444; font-size: 15px; line-height: 1.7; margin: 0 0 16px;">We are thrilled to welcome you as a confirmed participant of the <strong>{{tournamentName}}</strong>! Everything is set for an exceptional tournament experience, and we cannot wait to see you on the course.</p>

      <div style="background-color: ${BRAND.sand}; border-left: 4px solid ${BRAND.orange}; padding: 20px 24px; margin: 28px 0; border-radius: 0 8px 8px 0;">
        <p style="color: ${BRAND.green}; font-weight: 700; font-size: 15px; margin: 0 0 12px;">Your Details</p>
        <table style="width: 100%; border-collapse: collapse;">
          <tr>
            <td style="color: ${BRAND.gray}; padding: 6px 16px 6px 0; font-size: 14px; white-space: nowrap;">Registration Number</td>
            <td style="color: ${BRAND.dark}; font-weight: 600; padding: 6px 0; font-size: 14px;">{{registrationNumber}}</td>
          </tr>
          <tr>
            <td style="color: ${BRAND.gray}; padding: 6px 16px 6px 0; font-size: 14px; white-space: nowrap;">Shirt Size</td>
            <td style="color: ${BRAND.dark}; font-weight: 600; padding: 6px 0; font-size: 14px;">{{shirtSize}}</td>
          </tr>
        </table>
      </div>

      <div style="background-color: ${BRAND.sand}; border-left: 4px solid ${BRAND.green}; padding: 20px 24px; margin: 28px 0; border-radius: 0 8px 8px 0;">
        <p style="color: ${BRAND.green}; font-weight: 700; font-size: 15px; margin: 0 0 12px;">Tournament Schedule</p>
        <table style="width: 100%; border-collapse: collapse;">
          <tr>
            <td style="color: ${BRAND.gray}; padding: 6px 16px 6px 0; font-size: 14px; white-space: nowrap;">Dates</td>
            <td style="color: ${BRAND.dark}; font-weight: 600; padding: 6px 0; font-size: 14px;">{{tournamentDate}}</td>
          </tr>
          <tr>
            <td style="color: ${BRAND.gray}; padding: 6px 16px 6px 0; font-size: 14px; white-space: nowrap;">Venue</td>
            <td style="color: ${BRAND.dark}; font-weight: 600; padding: 6px 0; font-size: 14px;">{{venue}}</td>
          </tr>
        </table>
      </div>

      <p style="color: #444; font-size: 15px; line-height: 1.7; margin: 0 0 8px;"><strong>Before You Arrive:</strong></p>
      <ul style="color: #444; font-size: 15px; line-height: 1.8; margin: 0 0 24px; padding-left: 20px;">
        <li>Please arrive at least <strong>1 hour before</strong> your tee time for check-in and warm-up</li>
        <li>Bring a valid photo ID for registration verification</li>
        <li>Review the tournament rules and course layout on our website</li>
        <li>Ensure your golf equipment meets tournament regulations</li>
      </ul>

      <p style="color: #444; font-size: 15px; line-height: 1.7; margin: 0 0 8px;"><strong>On-Site Information:</strong></p>
      <ul style="color: #444; font-size: 15px; line-height: 1.8; margin: 0 0 24px; padding-left: 20px;">
        <li>Check-in and registration desk will be at the clubhouse entrance</li>
        <li>Your welcome pack (including tournament shirt) will be provided at check-in</li>
        <li>Complimentary refreshments will be available throughout the tournament</li>
        <li>Prize-giving ceremony will take place after the final round</li>
      </ul>

      <div style="text-align: center; margin: 32px 0;">
        <a href="https://ibomopen.com/schedule" style="display: inline-block; background-color: ${BRAND.orange}; color: #ffffff; text-decoration: none; padding: 14px 36px; border-radius: 8px; font-weight: 600; font-size: 15px; margin: 0 6px 8px;">View Full Schedule</a>
        <a href="https://ibomopen.com" style="display: inline-block; background-color: ${BRAND.green}; color: #ffffff; text-decoration: none; padding: 14px 36px; border-radius: 8px; font-weight: 600; font-size: 15px; margin: 0 6px 8px;">Visit Our Website</a>
      </div>

      <p style="color: #444; font-size: 15px; line-height: 1.7; margin: 0 0 4px;">If you have any questions or need assistance, please contact us at <a href="mailto:info@ibomopen.com" style="color: ${BRAND.orange}; text-decoration: none;">info@ibomopen.com</a></p>
      <p style="color: ${BRAND.dark}; font-size: 15px; line-height: 1.7; margin: 24px 0 0;">We look forward to seeing you at the Ibom Golf &amp; Country Club!<br><strong style="color: ${BRAND.green};">The Ibom Open Team</strong></p>`;

const adminInviteContent = `      <h2 style="color: ${BRAND.green}; margin: 0 0 8px; font-size: 22px; font-weight: 700;">You're Invited to the Admin Dashboard</h2>
      <p style="color: ${BRAND.gray}; font-size: 14px; margin: 0 0 28px;">Ibom Open Golf Tournament</p>
      <p style="color: ${BRAND.dark}; font-size: 16px; line-height: 1.6; margin: 0 0 16px;">Hello,</p>
      <p style="color: #444; font-size: 15px; line-height: 1.7; margin: 0 0 24px;">You have been invited to join the <strong>Ibom Open Golf Tournament</strong> admin team. Click the button below to set up your password and access the admin dashboard.</p>
      <div style="background-color: ${BRAND.sand}; border-left: 4px solid ${BRAND.orange}; padding: 20px 24px; margin: 0 0 32px; border-radius: 0 8px 8px 0;">
        <p style="color: ${BRAND.green}; font-weight: 700; font-size: 14px; margin: 0 0 8px;">What you'll have access to:</p>
        <ul style="color: #444; font-size: 14px; line-height: 1.8; margin: 0; padding-left: 18px;">
          <li>Tournament management and scheduling</li>
          <li>Player registrations and scoring</li>
          <li>Content and media management</li>
          <li>Financial tracking and reporting</li>
        </ul>
      </div>
      <div style="text-align: center; margin: 0 0 32px;">
        <a href="{{inviteLink}}" style="display: inline-block; background-color: ${BRAND.orange}; color: #ffffff; text-decoration: none; padding: 16px 40px; border-radius: 8px; font-weight: 700; font-size: 15px; letter-spacing: 0.3px;">Set Up Your Password</a>
      </div>
      <p style="color: #888; font-size: 13px; line-height: 1.6; margin: 0 0 4px; text-align: center;">This link will expire in 24 hours. If you did not expect this invitation, you can safely ignore this email.</p>
      <hr style="border: none; border-top: 1px solid #eee; margin: 28px 0;" />
      <p style="color: ${BRAND.dark}; font-size: 15px; line-height: 1.7; margin: 0;">Best regards,<br><strong style="color: ${BRAND.green};">The Ibom Open Team</strong></p>`;

export const interestConfirmationContent = `      <h2 style="color: ${BRAND.green}; margin: 0 0 24px; font-size: 22px; font-weight: 700;">Interest Received</h2>
      <p style="color: ${BRAND.dark}; font-size: 16px; line-height: 1.6; margin: 0 0 16px;">Dear {{firstName}} {{lastName}},</p>
      <p style="color: #444; font-size: 15px; line-height: 1.7; margin: 0 0 16px;">Thank you for expressing your interest in the <strong>Ibom Open Golf Tournament</strong>. We have received your details and our team will be in touch with you shortly to discuss your visit.</p>
      <div style="background-color: ${BRAND.sand}; border-left: 4px solid ${BRAND.orange}; padding: 20px 24px; margin: 28px 0; border-radius: 0 8px 8px 0;">
        <p style="color: ${BRAND.green}; font-weight: 700; font-size: 14px; margin: 0 0 12px;">Your Submission Summary</p>
        <table style="width: 100%; border-collapse: collapse;">
          <tr>
            <td style="color: ${BRAND.gray}; padding: 6px 16px 6px 0; font-size: 14px; white-space: nowrap;">Reference</td>
            <td style="color: ${BRAND.dark}; font-weight: 700; padding: 6px 0; font-size: 14px; font-family: monospace; letter-spacing: 0.05em;">{{reference}}</td>
          </tr>
          <tr>
            <td style="color: ${BRAND.gray}; padding: 6px 16px 6px 0; font-size: 14px; white-space: nowrap;">Arrival</td>
            <td style="color: ${BRAND.dark}; font-weight: 600; padding: 6px 0; font-size: 14px;">{{arrivalDate}}</td>
          </tr>
          <tr>
            <td style="color: ${BRAND.gray}; padding: 6px 16px 6px 0; font-size: 14px; white-space: nowrap;">Departure</td>
            <td style="color: ${BRAND.dark}; font-weight: 600; padding: 6px 0; font-size: 14px;">{{departureDate}}</td>
          </tr>
          <tr>
            <td style="color: ${BRAND.gray}; padding: 6px 16px 6px 0; font-size: 14px; white-space: nowrap;">Guests</td>
            <td style="color: ${BRAND.dark}; font-weight: 600; padding: 6px 0; font-size: 14px;">{{numAdults}} adult(s), {{numChildren}} child(ren)</td>
          </tr>
          <tr>
            <td style="color: ${BRAND.gray}; padding: 6px 16px 6px 0; font-size: 14px; white-space: nowrap;">Room Preference</td>
            <td style="color: ${BRAND.dark}; font-weight: 600; padding: 6px 0; font-size: 14px;">{{roomType}}</td>
          </tr>
        </table>
      </div>
      <p style="color: #444; font-size: 15px; line-height: 1.7; margin: 0 0 8px;"><strong>What happens next?</strong></p>
      <ul style="color: #444; font-size: 15px; line-height: 1.8; margin: 0 0 24px; padding-left: 20px;">
        <li>Our team will review your interest and availability</li>
        <li>We will contact you to confirm your booking and provide further details</li>
        <li>Please keep your reference number for correspondence</li>
      </ul>
      <div style="text-align: center; margin: 32px 0;">
        <a href="https://ibomopen.com" style="display: inline-block; background-color: ${BRAND.orange}; color: #ffffff; text-decoration: none; padding: 14px 36px; border-radius: 8px; font-weight: 600; font-size: 15px;">Visit Our Website</a>
      </div>
      <p style="color: #444; font-size: 15px; line-height: 1.7; margin: 0 0 4px;">Questions? Contact us at <a href="mailto:info@ibomopen.com" style="color: ${BRAND.orange}; text-decoration: none;">info@ibomopen.com</a></p>
      <p style="color: ${BRAND.dark}; font-size: 15px; line-height: 1.7; margin: 24px 0 0;">Best regards,<br><strong style="color: ${BRAND.green};">The Ibom Open Team</strong></p>`;

const announcementContent = `      <h2 style="color: ${BRAND.green}; margin: 0 0 8px; font-size: 24px; font-weight: 700;">{{headline}}</h2>
      <p style="color: ${BRAND.orange}; font-size: 14px; font-weight: 600; text-transform: uppercase; letter-spacing: 0.5px; margin: 0 0 28px;">Ibom Open Golf Tournament</p>
      <p style="color: ${BRAND.dark}; font-size: 16px; line-height: 1.6; margin: 0 0 16px;">Dear {{firstName}},</p>
      <p style="color: #444; font-size: 15px; line-height: 1.7; margin: 0 0 24px;">{{message}}</p>
      <div style="background-color: ${BRAND.sand}; border-left: 4px solid ${BRAND.orange}; padding: 20px 24px; margin: 28px 0; border-radius: 0 8px 8px 0;">
        <p style="color: ${BRAND.green}; font-weight: 700; font-size: 15px; margin: 0 0 8px;">Stay Connected</p>
        <p style="color: #444; font-size: 14px; line-height: 1.7; margin: 0;">Join our official WhatsApp group to receive live updates, connect with fellow participants, and get important announcements directly on your phone.</p>
      </div>
      <div style="text-align: center; margin: 32px 0;">
        <a href="https://chat.whatsapp.com/EHcCjeqxiqYFLPspf9b0k5" style="display: inline-block; background-color: #25D366; color: #ffffff; text-decoration: none; padding: 16px 40px; border-radius: 8px; font-weight: 700; font-size: 15px; letter-spacing: 0.3px;">Join WhatsApp Group</a>
      </div>
      <div style="background-color: ${BRAND.sand}; border-left: 4px solid ${BRAND.green}; padding: 20px 24px; margin: 28px 0; border-radius: 0 8px 8px 0;">
        <p style="color: ${BRAND.green}; font-weight: 700; font-size: 15px; margin: 0 0 8px;">Download the Official App</p>
        <p style="color: #444; font-size: 14px; line-height: 1.7; margin: 0 0 14px;">Get live scores, real-time leaderboards, tee times, and tournament updates right in your pocket.</p>
        <div>
          <a href="{{appStoreUrl}}" style="display: inline-block; margin: 0 6px 8px 0; text-decoration: none;">
            <img src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg" alt="Download on the App Store" style="height: 36px; width: auto;" />
          </a>
          <a href="{{playStoreUrl}}" style="display: inline-block; margin: 0 0 8px; text-decoration: none;">
            <img src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg" alt="Get it on Google Play" style="height: 36px; width: auto;" />
          </a>
        </div>
      </div>
      <div style="text-align: center; margin: 0 0 32px;">
        <a href="https://ibomopen.com" style="display: inline-block; background-color: ${BRAND.orange}; color: #ffffff; text-decoration: none; padding: 14px 36px; border-radius: 8px; font-weight: 600; font-size: 15px;">Visit Our Website</a>
      </div>
      <hr style="border: none; border-top: 1px solid #eee; margin: 28px 0;" />
      <p style="color: #444; font-size: 15px; line-height: 1.7; margin: 0 0 4px;">Questions? Reach us at <a href="mailto:info@ibomopen.com" style="color: ${BRAND.orange}; text-decoration: none;">info@ibomopen.com</a></p>
      <p style="color: ${BRAND.dark}; font-size: 15px; line-height: 1.7; margin: 24px 0 0;">See you soon,<br><strong style="color: ${BRAND.green};">The Ibom Open Team</strong></p>`;

const testContent = `      <h2 style="color: ${BRAND.green}; margin: 0 0 24px; font-size: 22px; font-weight: 700;">Test Email</h2>
      <p style="color: ${BRAND.dark}; font-size: 16px; line-height: 1.6; margin: 0 0 16px;">Hello,</p>
      <p style="color: #444; font-size: 15px; line-height: 1.7; margin: 0 0 16px;">This is a test email from the Ibom Open Golf Tournament website. If you are receiving this email, it means the email functionality is working correctly.</p>
      <div style="background-color: ${BRAND.sand}; border-left: 4px solid ${BRAND.orange}; padding: 20px 24px; margin: 28px 0; border-radius: 0 8px 8px 0;">
        <table style="width: 100%; border-collapse: collapse;">
          <tr>
            <td style="color: ${BRAND.gray}; padding: 6px 16px 6px 0; font-size: 14px;">Current Time</td>
            <td style="color: ${BRAND.dark}; font-weight: 600; padding: 6px 0; font-size: 14px;">{{date}}</td>
          </tr>
        </table>
      </div>
      <p style="color: ${BRAND.dark}; font-size: 15px; line-height: 1.7; margin: 24px 0 0;">Best regards,<br><strong style="color: ${BRAND.green};">The Ibom Open Team</strong></p>`;

export const TEMPLATE_TYPES: EmailTemplateType[] = [
  {
    id: 'admin_invite',
    name: 'Admin Invite',
    dbName: 'Admin Invite',
    description: 'Sent when an admin user is invited to register for the dashboard',
    placeholders: [
      { key: 'inviteLink', label: 'Invite / Setup Link', example: 'https://ibomopen.com/dashboard' },
    ],
    defaultSubject: "You're Invited — Ibom Open Admin Dashboard",
    defaultHtml: brandedLayout(adminInviteContent),
  },
  {
    id: 'registration_confirmation',
    name: 'Registration Confirmation',
    dbName: 'Registration Confirmation',
    description: 'Sent when a player registers for the tournament',
    placeholders: [
      { key: 'firstName', label: 'First Name', example: 'John' },
      { key: 'lastName', label: 'Last Name', example: 'Doe' },
      { key: 'registrationNumber', label: 'Registration #', example: 'IBO-2025-ABC123' },
      { key: 'shirtSize', label: 'Shirt Size', example: 'L' },
    ],
    defaultSubject: 'Ibom Open 2025 - Registration Confirmation',
    defaultHtml: brandedLayout(registrationContent),
  },
  {
    id: 'payment_confirmation',
    name: 'Payment Confirmation',
    dbName: 'Payment Confirmation',
    description: 'Sent when a payment is confirmed',
    placeholders: [
      { key: 'firstName', label: 'First Name', example: 'John' },
      { key: 'lastName', label: 'Last Name', example: 'Doe' },
      { key: 'tournamentName', label: 'Tournament Name', example: 'Ibom Open 2026' },
      { key: 'amount', label: 'Amount', example: '\u20A650,000' },
      { key: 'reference', label: 'Reference', example: 'TRX-123456' },
    ],
    defaultSubject: '{{tournamentName}} - Payment Confirmation',
    defaultHtml: brandedLayout(paymentContent),
  },
  {
    id: 'status_change',
    name: 'Status Change',
    dbName: 'Status Change',
    description: 'Sent when registration status is updated',
    placeholders: [
      { key: 'firstName', label: 'First Name', example: 'John' },
      { key: 'lastName', label: 'Last Name', example: 'Doe' },
      { key: 'status', label: 'Status', example: 'Approved' },
    ],
    defaultSubject: 'Ibom Open 2025 - Registration Status Update',
    defaultHtml: brandedLayout(statusChangeContent),
  },
  {
    id: 'interest_confirmation',
    name: 'Interest Form Confirmation',
    dbName: 'Interest Form Confirmation',
    description: 'Sent when a Ship Afrika customer submits an interest form',
    placeholders: [
      { key: 'firstName', label: 'First Name', example: 'John' },
      { key: 'lastName', label: 'Last Name', example: 'Doe' },
      { key: 'reference', label: 'Reference', example: 'SHIP-20260401-AB12' },
      { key: 'arrivalDate', label: 'Arrival Date', example: '7 June 2026' },
      { key: 'departureDate', label: 'Departure Date', example: '10 June 2026' },
      { key: 'numAdults', label: 'Adults', example: '2' },
      { key: 'numChildren', label: 'Children', example: '0' },
      { key: 'roomType', label: 'Room Type', example: 'Deluxe Room' },
    ],
    defaultSubject: 'Ibom Open - Interest Form Confirmation',
    defaultHtml: brandedLayout(interestConfirmationContent),
  },
  {
    id: 'announcement',
    name: 'Announcement',
    dbName: 'Announcement',
    description: 'Send announcements and countdown messages to players with a WhatsApp group CTA',
    placeholders: [
      { key: 'firstName', label: 'First Name', example: 'John' },
      { key: 'headline', label: 'Headline', example: 'Just Over 2 Weeks Away!' },
      { key: 'message', label: 'Message Body', example: 'The excitement is building! The Ibom Open 2026 is just over 2 weeks away and we cannot wait to welcome you to the Ibom Golf & Country Club. Make sure your clubs are ready and your game is sharp — it is going to be an unforgettable tournament.' },
    ],
    defaultSubject: 'Ibom Open — {{headline}}',
    defaultHtml: brandedLayout(announcementContent),
  },
  {
    id: 'welcome',
    name: 'Welcome Email',
    dbName: 'Welcome Email',
    description: 'Sent to welcome confirmed participants with arrival and schedule details',
    placeholders: [
      { key: 'firstName', label: 'First Name', example: 'John' },
      { key: 'lastName', label: 'Last Name', example: 'Doe' },
      { key: 'registrationNumber', label: 'Registration #', example: 'IBO-2025-ABC123' },
      { key: 'shirtSize', label: 'Shirt Size', example: 'L' },
      { key: 'tournamentName', label: 'Tournament Name', example: 'Ibom Open 2026' },
      { key: 'tournamentDate', label: 'Tournament Date', example: 'June 7 – June 8, 2026' },
      { key: 'venue', label: 'Venue', example: 'Ibom Golf & Country Club, Uyo' },
    ],
    defaultSubject: 'Welcome to {{tournamentName}} - Important Information',
    defaultHtml: brandedLayout(welcomeContent),
  },
];

export const TEST_TEMPLATE = {
  subject: 'Ibom Open - Test Email',
  html: brandedLayout(testContent),
};

export function substitutePreviewValues(
  html: string,
  placeholders: TemplatePlaceholder[]
): string {
  let result = html;
  for (const p of placeholders) {
    result = result.replace(new RegExp(`\\{\\{${p.key}\\}\\}`, 'g'), p.example);
  }
  const now = new Date().toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
  result = result.replace(/\{\{date\}\}/g, now);
  result = result.replace(/\{\{email\}\}/g, 'john.doe@example.com');
  result = result.replace(/\{\{tournamentName\}\}/g, 'Ibom Open 2026');
  result = result.replace(/\{\{tournamentDate\}\}/g, 'June 7 \u2013 June 8, 2026');
  result = result.replace(/\{\{venue\}\}/g, 'Ibom Golf & Country Club, Uyo');
  result = result.replace(/\{\{appStoreUrl\}\}/g, '#');
  result = result.replace(/\{\{playStoreUrl\}\}/g, '#');
  return result;
}

export function substituteAppLinks(html: string, appStoreUrl: string, playStoreUrl: string): string {
  let result = html;
  result = result.replace(/\{\{appStoreUrl\}\}/g, appStoreUrl || '#');
  result = result.replace(/\{\{playStoreUrl\}\}/g, playStoreUrl || '#');
  return result;
}

export { brandedLayout };
